export default "__VITE_ASSET__CXsw6ncv__"